import log from 'loglevel';

const loglevel = log.getLogger("auth");
loglevel.setLevel("error");

export { loglevel };
